import { type ReactNode } from 'react'

/**
 * "Nothing matched that" — never "there are none" (M24-T03, M25-T01).
 *
 * Filtered to nothing is NOT the same as having nothing, and the two must never
 * share a sentence: "there are none" when the honest answer is "none matching
 * that" is how a concierge concludes a patient never called. The whole of M23
 * gap A5 is this distinction.
 *
 * Extracted from `DataTable` when M25-T01 gave the two medication card lists a
 * filter of their own. Both spellings of the sentence would otherwise drift,
 * and the one that drifts is the one nobody is looking at.
 *
 * `scope` is the second line, and it is the honest part: a list that is capped
 * or paginated must say the filter reached only what is loaded. A list that
 * holds its entire queue says nothing extra, because there is nothing to
 * qualify — and that silence is a claim, so pass `null` only when it is true.
 */
export function FilteredEmpty({
  query,
  scope = null,
}: {
  query: string
  scope?: ReactNode
}) {
  return (
    <div className="border-t border-line-1 px-6 py-10 text-center">
      <p className="text-sm text-ink-1">No rows here match “{query.trim()}”.</p>
      {scope !== null && <p className="mt-1 text-sm text-ink-3">{scope}</p>}
    </div>
  )
}
